export const defaultProject = {
    label: "",
    client_id: undefined,
    ville_id: undefined,
    adresse: "",
    is_active: true,
    client: { denomination: "", ice: "", client_type: "" },
};
